import React from "react";
import Dropdown from "./dropdown";

interface RowCountDropdownProps {
  pageSize: number;
  setPageSize: (size: number) => void;
  options?: number[];
  label?: string;
}

const RowCountDropdown: React.FC<RowCountDropdownProps> = ({
  pageSize,
  setPageSize,
  options = [10, 50, 100],
  label = "Rows:"
}) => {
  const rowOptions = options.map(size => ({ value: size }));
  const selectedOption = { value: pageSize };

  return (
    <div className="flex items-center">
      <span className="text-sm text-gray-900 mr-2 font-space-grotesk">{label}</span>
      <Dropdown
        options={rowOptions}
        onChange={(option) => setPageSize(option.value)}
        renderOption={(option) => option.value.toString()}
        selectedOption={selectedOption}
      />
    </div>
  );
};

export default RowCountDropdown;